import React from 'react';
import RightArrowIcon from 'material-ui/svg-icons/navigation/chevron-right';
import { Card, CardTitle, CardText } from 'material-ui/Card';
import { TEXT_COLOR, BUTTON_COLOR} from '../constants/colours'
const plantImg = '../images/plant_white.jpg';
import language, {languages} from '../constants/languages'
import { isEmpty } from 'lodash'

const LoanProducts = (props) => (
  !isEmpty(props.selectedLanguage) && <div className='text-color'>
    <Card>
      <div className="container some-div-overlay">
        <img width='100%' height='300' src={plantImg} alt="Our product offerings" />
        <div className="centered">
          <div className="custom-h2 text-color"> {language[props.selectedLanguage].product_page_img_text} </div>
        </div>
      </div>
    </Card>
    <Card>
      <CardTitle
        titleColor={BUTTON_COLOR}
        subtitleColor={TEXT_COLOR}
        subtitleStyle={{fontSize:18, marginTop:10}}
        title={language[props.selectedLanguage].product_page_title}
        subtitle={language[props.selectedLanguage].product_page_subtitle}
      />
      <CardText
        color={TEXT_COLOR}>
        <div id='lap' className='text-div'>
          <h3>{language[props.selectedLanguage].product_page_features}</h3>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_feature1}
          </p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_feature2}
          </p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_feature3}</p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_feature4}</p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_feature5}</p>
          <h3>{language[props.selectedLanguage].mortgage_loan}</h3>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_loan1}</p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_loan2} </p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_loan3}</p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_loan4} </p>
          <h3>{language[props.selectedLanguage].vehicle_loan}</h3>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].vehicle_loan_desc1}</p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].vehicle_loan_desc2} </p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].vehicle_loan_desc3}</p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].vehicle_loan_desc4} </p>
          <h3>{language[props.selectedLanguage].product_page_loan_requirements}</h3>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_requirements1}
          </p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_requirements2}</p>
          <p><RightArrowIcon viewBox="0 -6 24 24" />{language[props.selectedLanguage].product_page_requirements3}
          </p>
        </div>
      </CardText>
    </Card>
  </div>
);

export default LoanProducts;



// WEBPACK FOOTER //
// ./src/components/LoanProducts.js